import React, {useState} from 'react';
import Spacer from "../../../Components/Spacer";
import ResidentialAddressDetails from "./ResidentialAddressDetails";
import CorrespondenceAddressDetails from "./CorrespondenceAddressDetails";
import BasicDetails from "./BasicDetails";

const ClientDetails = (props) => {
    const {
        data = {
            'title':                                         '',
            'first_name':                                    '',
            'last_name':                                     '',
            'email':                                         '',
            'phone_prefix':                                  '',
            'phone_number':                                  '',
            'dual_nationality':                              0,
            'primary_nationality':                           '',
            'secondary_nationality':                         '',
            'date_of_birth':                                 '',
            'national_insurance_number':                     '',
            'password':                                      '',
            'phone_password':                                '',
            'occupation':                                    '',
            'residential_address_line_1':                    '',
            'residential_address_line_2':                    '',
            'residential_town_city':                         '',
            'residential_state_county':                      '',
            'residential_postcode':                          '',
            'residential_country':                           '',
            'residential_occupied_since_year':               '',
            'residential_occupied_since_month':              '',
            'permanent_address_is_correspondence_address':   0,
            'correspondence_address_line_1':                 '',
            'correspondence_address_line_2':                 '',
            'correspondence_town_city':                      '',
            'correspondence_state_county':                   '',
            'correspondence_postcode':                       '',
            'correspondence_country':                        '',
            'correspondence_occupied_since_year':            '',
            'correspondence_occupied_since_month':           '',
        },
        errors,
        submitting,
        updateField,
        index
    } = props;

    return (
        <React.Fragment>
            <BasicDetails
                index={index}
                data={data}
                onChange={(field, value) => updateField(field, value)}
                disabled={submitting}
                errors={errors}
            />
            <Spacer />
            <ResidentialAddressDetails
                data={data}
                onChange={(field, value) => updateField(field, value)}
                disabled={submitting}
                errors={errors}
            />

            {data.permanent_address_is_correspondence_address === '0' || data.permanent_address_is_correspondence_address === 0 ? (
                <>
                    <Spacer />
                    <CorrespondenceAddressDetails
                        data={data}
                        onChange={(field, value) => updateField(field, value)}
                        disabled={submitting}
                        errors={errors}
                    />
                </>
            ) : null}
        </React.Fragment>
    );
}

export default ClientDetails;
